import ROBOBOLSA_EXT_1 from "./ROBOBOLSA_EXT_1";
export default {
  ROBOBOLSA_EXT_1,
};
